$('.top_absolute .close').on('click', function(e) {
    e.preventDefault();
    $(this).parent().hide();
});